import React from "react";
import { useReveal } from "../hooks/useReveal";

const ITEMS = [
  {
    name: "L-Theanine",
    role: "Calm Focus",
    desc: "Supports calm focus and smoother cognitive performance under pressure.",
  },
  {
    name: "Alpha-GPC",
    role: "Clarity",
    desc: "Supports attention, mental clarity, and the mind-muscle connection.",
  },
  {
    name: "L-Tyrosine",
    role: "Resilience",
    desc: "Supports alertness, mental resilience, and cognitive performance during demanding moments.",
  },
];

export default function Formulation() {
  const head = useReveal();
  return (
    <section
      id="formulation"
      data-testid="formulation-section"
      className="section relative grid-bg overflow-hidden"
    >
      <img
        src="/assets/macro-blue.jpg"
        alt=""
        aria-hidden
        loading="lazy"
        className="hidden lg:block pointer-events-none absolute top-0 right-0 w-[42%] max-w-[700px] h-full object-cover opacity-25 mix-blend-screen"
        style={{ maskImage: "linear-gradient(to left, #000 30%, transparent 95%)", WebkitMaskImage: "linear-gradient(to left, #000 30%, transparent 95%)" }}
      />
      <div className="container-x relative z-10">
        <div ref={head} className="reveal flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12 lg:mb-16">
          <div>
            <span className="font-mono text-sm uppercase tracking-[0.3em] text-white/55">
              / 04 — Formulation
            </span>
            <h2
              className="kinetic mt-6"
              style={{ fontSize: "clamp(2.6rem, 6vw, 5.4rem)", lineHeight: 0.95 }}
            >
              <span className="gradient-text">ENGINEERED FOR</span>
              <br />
              <span className="outline-text-blue">CLEAN PERFORMANCE.</span>
            </h2>
          </div>
          <p className="text-white/55 max-w-sm text-base lg:text-lg">
            Designed to support the chewing experience. Never overpower it.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 border border-white/5 rounded-2xl overflow-hidden">
          {ITEMS.map((it, i) => (
            <Cell key={i} item={it} i={i} />
          ))}
        </div>

        <p className="mt-8 text-white/45 text-sm font-mono uppercase tracking-[0.22em]">
          Three actives. Built to support the chew. Not replace it.
        </p>
      </div>
    </section>
  );
}

function Cell({ item, i }) {
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`formulation-${i}`}
      className="reveal bg-[#050608] p-8 lg:p-10 hover:bg-[#070a10] transition-colors duration-500 group"
    >
      <div className="flex items-start justify-between mb-6">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">
          / 0{i + 1}
        </span>
        <span
          className="font-mono text-xs uppercase tracking-[0.25em]"
          style={{ color: "var(--blue-bright)" }}
        >
          {item.role}
        </span>
      </div>
      <h3 className="font-display text-3xl lg:text-4xl uppercase text-white">
        {item.name}
      </h3>
      <p className="mt-5 text-white/65 text-sm lg:text-base leading-relaxed max-w-md">
        {item.desc}
      </p>
    </div>
  );
}
